(function () {
  if (window.customElements.get('build-form')) return;

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  class BuildForm extends HTMLElement {
    constructor() {
      super();

      // Klaviyo config mirrors the sitewide onsite.js setup in layout/theme.liquid.
      // If you ever change the Klaviyo account there, update this too.
      this.KLAVIYO_COMPANY_ID = 'SU7xGh';
      this.KLAVIYO_PLATFORM = 'shopify';

      this.itemContainers = Array.from(this.querySelectorAll('[data-items]'));
      this.topTotal = document.querySelector('[data-money-convertible]');
      this.total = this.querySelector('[data-total]');
      this.addToCartButton = this.querySelector('[data-add-to-cart]');
      this.products = Array.from(this.querySelectorAll('[data-item]'));
      this.product = this.dataset.product;
      this.sections = Array.from(this.querySelectorAll('[data-section]'));
      this.options = Array.from(this.querySelectorAll('[data-value]'));
      this.moneyConvertible = document.querySelector('[data-money-convertible]');
      this.totalObserver = null;
      this.notifyButton = this.querySelector('[data-notify-trigger]');
    }

    connectedCallback() {
      this.preselectItems();
      this.addListeners();
      this.observeTotalChanges();
      this.updateMoneyConvertible();
      this.updateButtonLabel();
    }

    openBackInStockModal(soldOutVariants) {
      if (soldOutVariants.length === 0) return;
      if (document.querySelector('[data-bis-buildform-modal]')) return;

      const multiple = soldOutVariants.length > 1;
      const firstVariant = soldOutVariants[0];
      const headlineTitle = multiple
        ? this.product || 'Notify Me When Available'
        : firstVariant.displayTitle ||
          firstVariant.productTitle ||
          'Notify Me When Available';
      const bodyContent = multiple
        ? 'Select an out of stock item below. Register to receive a notification when it comes back in stock.'
        : 'Register to receive a notification when this item comes back in stock.';
      const variantOptions = soldOutVariants
        .map((variant) => {
          const label = this.formatSoldOutOptionLabel(variant);
          return `<option value="${escapeHtml(variant.variantId)}">${escapeHtml(label)}</option>`;
        })
        .join('');

      const dialogId = `bis-buildform-title-${Date.now()}`;
      const previouslyFocused = document.activeElement;
      const modal = document.createElement('div');
      modal.setAttribute('data-bis-buildform-modal', '');
      modal.innerHTML = `
        <div data-bis-overlay style="
          position:fixed; inset:0; z-index:999999;
          background:rgba(0,0,0,.45); display:flex; align-items:center; justify-content:center;
          padding:16px;">
          <div role="dialog" aria-modal="true" aria-labelledby="${dialogId}"
            style="background:#fff; width:100%; max-width:520px; padding:22px 26px 18px; box-shadow:0 20px 60px rgba(0,0,0,.25); position:relative;">
            <button type="button" aria-label="Close" data-bis-close
              style="position:absolute; right:18px; top:14px; z-index:2; border:0; background:transparent; font-size:28px; line-height:28px; cursor:pointer; color:#374151; font-weight:400;">
              ×
            </button>

            <div style="margin-top:10px;">
              <div data-bis-headline id="${dialogId}" style="font-family: Georgia, 'Times New Roman', Times, serif; font-size:28px; line-height:1.1; color:#0742e3; font-weight:500;">
                ${escapeHtml(headlineTitle)}
              </div>
              <div style="margin-top:14px; font-family: Georgia, 'Times New Roman', Times, serif; font-size:14px; line-height:1.4; color:#2b2b2b;">
                ${bodyContent}
              </div>
            </div>

            <form data-bis-form style="margin-top:16px;">
              <div style="margin-top:10px;">
                <label for="bis-variant-select" style="display:block; margin-bottom:6px; font-family: Georgia, 'Times New Roman', Times, serif; font-size:14px; color:#2b2b2b;">
                  Item
                </label>
                <select data-bis-variant id="bis-variant-select"
                  style="width:100%; padding:10px 12px; border:1px solid #ddd; border-radius:2px; font-family: Georgia, 'Times New Roman', Times, serif; color:#2b2b2b;">
                  ${variantOptions}
                </select>
              </div>

              <label for="bis-email-input" style="display:block; margin-top:14px; margin-bottom:6px; font-family: Georgia, 'Times New Roman', Times, serif; font-size:14px; color:#2b2b2b;">
                Email
              </label>
              <input data-bis-email id="bis-email-input" type="email" required autocomplete="email"
                style="width:100%; padding:10px 12px; border:1px solid #ddd; border-radius:2px; font-family: Georgia, 'Times New Roman', Times, serif; font-size:14px; color:#0742e3;"
                placeholder="Email" />

              <div data-bis-error role="alert" style="display:none; margin-top:10px; color:#c72e2f; font-weight:700;"></div>
              <div data-bis-success role="status" style="display:none; margin-top:10px; color:#1B9500; font-weight:800;">
                You're in! We'll let you know when it's back.
              </div>

              <button type="submit"
                style="margin-top:16px; width:100%; padding:14px 16px; background:#0742e3; color:#fff; font-weight:800; border:0; cursor:pointer; font-family: Georgia, 'Times New Roman', Times, serif; border-radius:2px;">
                NOTIFY ME
              </button>
            </form>
          </div>
        </div>
      `;

      document.body.appendChild(modal);

      const dialog = modal.querySelector('[role="dialog"]');
      const closeModal = () => {
        modal.remove();
        document.removeEventListener('keydown', onKeyDown);
        if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
          previouslyFocused.focus();
        }
      };

      const getFocusable = () =>
        Array.from(
          dialog.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          )
        ).filter((el) => !el.disabled && el.offsetParent !== null);

      const onKeyDown = (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = getFocusable();
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };

      document.addEventListener('keydown', onKeyDown);

      const closeBtn = modal.querySelector('[data-bis-close]');
      closeBtn?.addEventListener('click', closeModal);
      modal.querySelector('[data-bis-overlay]')?.addEventListener('click', (event) => {
        if (event.target === event.currentTarget) closeModal();
      });

      (getFocusable()[0] || closeBtn)?.focus();

      const form = modal.querySelector('[data-bis-form]');
      const variantSelect = modal.querySelector('[data-bis-variant]');
      const headlineEl = modal.querySelector('[data-bis-headline]');
      const emailInput = modal.querySelector('[data-bis-email]');
      const errorEl = modal.querySelector('[data-bis-error]');
      const successEl = modal.querySelector('[data-bis-success]');
      const submitBtn = form.querySelector('button[type="submit"]');

      if (multiple && headlineEl) {
        variantSelect.addEventListener('change', () => {
          const selected = soldOutVariants.find(
            (variant) => variant.variantId === variantSelect.value
          );
          if (selected?.displayTitle) {
            headlineEl.textContent = selected.displayTitle;
          }
        });
      }

      const submitBackInStock = async () => {
        errorEl.style.display = 'none';
        errorEl.textContent = '';
        successEl.style.display = 'none';

        const email = emailInput.value.trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          errorEl.textContent = 'Please enter a valid email.';
          errorEl.style.display = 'block';
          return;
        }

        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';

        try {
          const selectedVariantId = variantSelect.value;
          if (!selectedVariantId) {
            throw new Error('Please select an item to notify.');
          }
          const catalogVariantId = `$${this.KLAVIYO_PLATFORM}:::$default:::${selectedVariantId}`;

          const res = await fetch(
            `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(
              this.KLAVIYO_COMPANY_ID
            )}`,
            {
              method: 'POST',
              headers: {
                revision: '2024-02-15',
                'Content-Type': 'application/json',
                'X-Klaviyo-Onsite': '1',
              },
              body: JSON.stringify({
                data: {
                  type: 'back-in-stock-subscription',
                  attributes: {
                    channels: ['EMAIL'],
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: { email },
                      },
                    },
                  },
                  relationships: {
                    variant: {
                      data: {
                        type: 'catalog-variant',
                        id: catalogVariantId,
                      },
                    },
                  },
                },
              }),
            }
          );

          if (!res.ok) {
            const txt = await res.text().catch(() => '');
            throw new Error(txt || `HTTP ${res.status}`);
          }

          submitBtn.style.display = 'none';
          successEl.style.display = 'block';
        } catch (err) {
          errorEl.textContent =
            err instanceof Error ? err.message : 'Subscription failed.';
          errorEl.style.display = 'block';
          submitBtn.disabled = false;
          submitBtn.textContent = 'NOTIFY ME';
        }
      };

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        submitBackInStock().catch((error) => {
          console.error('Error submitting back-in-stock form:', error);
        });
      });
    }

    formatSoldOutOptionLabel(variant) {
      if (variant.displayTitle) {
        return variant.displayTitle;
      }

      const variantTitle = (variant.variantTitle || '').trim();
      const isDefaultVariant =
        variantTitle === '' || variantTitle.toLowerCase() === 'default title';

      if (isDefaultVariant) {
        return variant.productTitle || 'Out of Stock';
      }

      return variantTitle || variant.productTitle || 'Out of Stock';
    }

    getActiveSoldOutVariantContexts() {
      const seenVariantIds = new Set();

      return this.products.reduce((contexts, el) => {
        if (
          !el.classList.contains('active') ||
          !el.classList.contains('sold-out')
        ) {
          return contexts;
        }

        const variantId = el.getAttribute('data-item');
        if (!variantId || seenVariantIds.has(variantId)) {
          return contexts;
        }

        seenVariantIds.add(variantId);
        contexts.push({
          variantId,
          productTitle: el.getAttribute('data-klaviyo-product-title') ?? '',
          variantTitle:
            el.getAttribute('data-klaviyo-variant-title') ??
            el.textContent?.trim() ??
            '',
          displayTitle: el.getAttribute('data-klaviyo-display-title') ?? '',
        });

        return contexts;
      }, []);
    }

    ensureNotifyButton() {
      const buttonContainer = this.querySelector('.varaint_right_add_cart');
      if (!buttonContainer) return null;
      buttonContainer.style.flexDirection = 'column';
      buttonContainer.style.gap = '0.5rem';

      if (!this.notifyButton) return null;

      if (!this.notifyButton._bisNotifyClickBound) {
        this.notifyButton._bisNotifyClickBound = true;
        this.notifyButton.addEventListener('click', (e) => {
          e.preventDefault();

          const soldOutVariants = this.getActiveSoldOutVariantContexts();
          if (soldOutVariants.length === 0) return;

          this.openBackInStockModal(soldOutVariants);
        });
      }

      return this.notifyButton;
    }

    preselectItems() {
      this.products.forEach((el) => {
        if (
          el.getAttribute('data-selected') === 'true' &&
          el.getAttribute('data-selected-condition') === 'false'
        ) {
          const parent = el.closest('[data-items]');

          // If the default item is sold out, try to activate an in-stock alternative
          // from the same [data-items] group instead
          let itemToActivate = el;
          if (el.classList.contains('sold-out')) {
            const inStockAlternative = Array.from(
              parent.querySelectorAll('[data-item]')
            ).find((item) => item !== el && !item.classList.contains('sold-out'));
            if (inStockAlternative) {
              itemToActivate = inStockAlternative;
            }
            // If no in-stock alternative exists, fall through with the sold-out item
            // so the "OUT OF STOCK" state is still shown correctly
          }

          itemToActivate.classList.add('active');

          let total = 0;
          parent?.querySelectorAll('[data-item]').forEach((item) => {
            if (item.classList.contains('active')) {
              total += Number(item.getAttribute('data-price')) / 100;
            }
          });

          const listPriceElement = parent?.querySelector('[data-list-price]');
          if (listPriceElement) {
            listPriceElement.innerHTML = total > 0 ? '+ $' + total.toFixed(2) : '';
          }
        }
      });

      this.calculateTotals();
      this.products
        .filter((el) => el.classList.contains('active'))
        .forEach((el) => this.checkConditionalSelections(el));
      this.updateButtonLabel();
    }

    addListeners() {
      const buildUI = document.querySelector('ul[data-items]');

      if (buildUI) {
        const listItems = Array.from(buildUI.querySelectorAll('li')).slice(0, -1);
        const gallery = document.querySelector('.product_gallery');

        buildUI.addEventListener('click', () => {
          const displayedImage =
            gallery?.querySelector('.gallery-cell.is-selected img') ||
            gallery?.querySelector('.gallery-cell img');
          if (!displayedImage) return;

          listItems.forEach((mainItem) => {
            if (mainItem.classList.contains('active')) {
              const altImage = mainItem
                .querySelector('img')
                ?.getAttribute('data-altimage');
              if (altImage) {
                displayedImage.src = altImage;
              }
            }
          });
        });
      }

      this.sections.forEach((section) => {
        const options = Array.from(
          section.querySelectorAll('[data-value]')
        ).filter((el) => el instanceof HTMLElement);

        options.forEach((option) => {
          option.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              option.click();
            }
          });
          option.addEventListener('click', () => {
            const currentChoice = section.getAttribute('data-choice');
            const optionValue = option.getAttribute('data-value') ?? '';

            // Check if clicking ANY option when one is already selected (toggle off)
            if (currentChoice) {
              // Remove data-choice from section
              section.removeAttribute('data-choice');

              // Remove border from all options in this section
              options.forEach((opt) => {
                opt.style.border = '2px solid transparent';
              });

              // Hide sections that were shown by the previous selection
              this.sections.forEach((outsideSections) => {
                const outsideSectionValue =
                  outsideSections.getAttribute('data-section');
                if (outsideSectionValue === currentChoice) {
                  outsideSections.classList.add('hidden');
                }
              });

              // Clear products associated with this section's group
              this.products.forEach((el) => {
                if (
                  section.getAttribute('data-group') ===
                  el.getAttribute('data-group')
                ) {
                  const parent = el.closest('[data-items]');
                  if (parent && !parent.hasAttribute('data-multiselect')) {
                    parent.querySelectorAll('[data-item]').forEach((item) => {
                      item.classList.remove('active');
                    });
                  }
                  if (parent) {
                    const listPrice = parent.querySelector('[data-list-price]');
                    if (listPrice) listPrice.innerHTML = '';
                  }
                }
              });

              this.calculateTotals();
              this.updateButtonLabel();
              return; // Exit early after unselecting
            }

            // Original selection logic continues below
            section.setAttribute('data-choice', optionValue);

            options.forEach((outsideOptions) => {
              if (
                section.getAttribute('data-choice') ===
                outsideOptions.getAttribute('data-value')
              ) {
                outsideOptions.style.border = '2px solid #0742e3';
              } else {
                outsideOptions.style.border = '2px solid transparent';
                this.products.forEach((el) => {
                  if (
                    section.getAttribute('data-group') ===
                    el.getAttribute('data-group')
                  ) {
                    const parent = el.closest('[data-items]');
                    if (parent && !parent.hasAttribute('data-multiselect')) {
                      parent.querySelectorAll('[data-item]').forEach((item) => {
                        if (el !== item) {
                          item.classList.remove('active');
                        }
                      });
                    }
                    this.calculateTotals();
                    if (parent) {
                      const listPrice = parent.querySelector('[data-list-price]');
                      if (listPrice) listPrice.innerHTML = '';
                    }
                  }
                });
              }
            });

            this.sections.forEach((outsideSections) => {
              if (
                outsideSections.getAttribute('data-section') ===
                option.getAttribute('data-value')
              ) {
                outsideSections.classList.remove('hidden');
              } else if (
                outsideSections
                  .getAttribute('data-disable')
                  ?.includes(option.getAttribute('data-value') ?? '')
              ) {
                outsideSections.classList.add('hidden');
              }
            });
            this.updateButtonLabel();
          });
        });
      });

      this.products.forEach((el) => {
        el.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            el.click();
          }
        });
        el.addEventListener('click', () => {
          let total = 0;
          const parent = el.closest('[data-items]');
          if (parent && !parent.hasAttribute('data-multiselect')) {
            parent.querySelectorAll('[data-item]').forEach((item) => {
              if (el !== item) {
                item.classList.remove('active');
                this.checkConditionalSelections(item);
              }
            });
          }
          el.classList.toggle('active');

          // Check for conditional selections when item becomes active
          this.checkConditionalSelections(el);

          parent?.querySelectorAll('[data-item]').forEach((item) => {
            if (item.classList.contains('active')) {
              total += Number(item.getAttribute('data-price')) / 100;
            }
          });

          const listPriceElement = parent?.querySelector('[data-list-price]');
          if (listPriceElement) {
            listPriceElement.innerHTML = total > 0 ? '+ $' + total.toFixed(2) : '';
          }

          this.calculateTotals();
          this.updateButtonLabel();
        });
      });

      this.addToCartButton?.addEventListener('click', () => {
        if (this.addToCartButton?.hasAttribute('disabled')) {
          return;
        }
        this.addToCart().catch((error) => {
          console.error('Error adding to cart:', error);
        });
      });
    }

    checkConditionalSelections(selectedItem) {
      const selectedValue = selectedItem.getAttribute('data-item');
      const isSelectedItemActive = selectedItem.classList.contains('active');

      this.products.forEach((el) => {
        const conditionValue = el.getAttribute('data-selected-condition');
        const isSelected = el.getAttribute('data-selected') === 'true';

        if (isSelected && conditionValue === selectedValue) {
          const parent = el.closest('[data-items]');

          if (isSelectedItemActive && !el.classList.contains('active')) {
            // Add conditional item when main item is selected
            el.classList.add('active');
          } else if (!isSelectedItemActive && el.classList.contains('active')) {
            // Remove conditional item when main item is deselected
            el.classList.remove('active');
          }

          let total = 0;
          parent?.querySelectorAll('[data-item]').forEach((item) => {
            if (item.classList.contains('active')) {
              total += Number(item.getAttribute('data-price')) / 100;
            }
          });

          const listPriceElement = parent?.querySelector('[data-list-price]');
          if (listPriceElement) {
            listPriceElement.innerHTML = total > 0 ? '+ $' + total.toFixed(2) : '';
          }
        }
      });

      // Recalculate totals after conditional selections
      this.calculateTotals();
    }

    syncPressedState() {
      this.querySelectorAll('[role="button"][aria-pressed]').forEach((el) => {
        el.setAttribute(
          'aria-pressed',
          el.classList.contains('active') ? 'true' : 'false'
        );
      });
    }

    calculateTotals() {
      this.syncPressedState();
      const total = this.products.reduce((sum, el) => {
        if (el.classList.contains('active')) {
          const price = Number(el.getAttribute('data-price')) || 0;
          return sum + price / 100;
        }
        return sum;
      }, 0);

      if (this.total) this.total.innerHTML = total.toFixed(2);
      if (this.topTotal) this.topTotal.innerHTML = `$${total.toFixed(2)}`;
      this.updateMoneyConvertible();
    }

    updateButtonLabel() {
      const hasUnavailable = this.products.some(
        (el) =>
          el.classList.contains('active') && el.classList.contains('sold-out')
      );

      if (this.addToCartButton) {
        const labelEl = this.addToCartButton.querySelector(
          '[data-add-to-cart-label]'
        );

        if (hasUnavailable) {
          this.addToCartButton.setAttribute('disabled', 'true');
          this.addToCartButton.classList.add('disabled');
          if (labelEl) labelEl.textContent = 'OUT OF STOCK';
        } else {
          this.addToCartButton.removeAttribute('disabled');
          this.addToCartButton.classList.remove('disabled');

          const addToCartLabel =
            this.addToCartButton.getAttribute('data-addtocart-label') ??
            'ADD TO CART';
          if (labelEl) labelEl.textContent = addToCartLabel;
        }
      }
      this.updateNotifyButton(hasUnavailable);
    }

    updateNotifyButton(hasUnavailable) {
      const notifyButton = this.ensureNotifyButton();
      if (!notifyButton) return;

      if (!hasUnavailable) {
        notifyButton.classList.add('hidden');
        return;
      }

      notifyButton.classList.remove('hidden');
    }

    async addToCart() {
      const hasUnavailable = this.products.some(
        (el) =>
          el.classList.contains('active') && el.classList.contains('sold-out')
      );

      if (hasUnavailable) {
        return;
      }

      const items = [];
      this.products.forEach((el) => {
        if (
          el.classList.contains('active') &&
          el.getAttribute('data-id') !== '0' &&
          !el.classList.contains('sold-out')
        ) {
          items.push({
            id: Number(el.getAttribute('data-item')),
            quantity: 1,
            properties: {
              Package: this.product,
            },
          });
        }
      });

      const hasRequired =
        this.querySelectorAll('[data-required]').length ===
        this.querySelectorAll('[data-required] .active').length;

      if (items.length > 0 && hasRequired) {
        document
          .querySelector('.rackBuilder-alert')
          ?.setAttribute('style', 'display: none');

        await this.submitToCart(items);
      } else if (!hasRequired) {
        document
          .querySelector('.rackBuilder-alert')
          ?.setAttribute('style', 'display: block');
        this.querySelectorAll('[data-required]').forEach((el) => {
          if (!el.querySelector('.active')) {
            el.setAttribute(
              'style',
              'border: 2px solid #0742e3; border-radius: 10px'
            );
          } else {
            el.setAttribute('style', 'border: 0px solid transparent');
          }
        });
      }
    }

    async submitToCart(items) {
      if (this.addToCartButton) {
        this.addToCartButton.setAttribute('disabled', 'true');
        this.addToCartButton.classList.add('disabled');
      }

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!addRes.ok) {
          const errorBody = await addRes.json().catch(() => null);
          throw new Error(
            errorBody?.description || `Cart error: ${addRes.status}`
          );
        }

        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        this.syncCart(cart);
        document.dispatchEvent(new CustomEvent('cart:added', { detail: cart }));
        this.flashAddedToCart();
      } catch (error) {
        console.error('Error adding build-form items to cart:', error);
      } finally {
        this.updateButtonLabel();
      }
    }

    // Mirrors the checkmark feedback used by the theme's classic add-to-cart
    // button (assets/app.js .ajax-submit handler).
    flashAddedToCart() {
      const checkmark = this.addToCartButton?.querySelector('.checkmark');
      if (!checkmark) return;
      checkmark.classList.add('checkmark-active');
      window.setTimeout(() => {
        checkmark.classList.remove('checkmark-active');
      }, 1000);
    }

    // Minimal cart sync consistent with assets/variant-selector.js: updates the
    // cart count badge and reveals the mini-cart, then lets the rest of the
    // theme react via the cart:updated event.
    syncCart(cart) {
      document
        .querySelectorAll('.cart_count')
        .forEach((el) => (el.textContent = cart.item_count));
      if (!window.PXUTheme?.theme_settings?.enable_cart_drawer) {
        document
          .querySelector('.top-bar--right-menu .cart-container')
          ?.classList.add('active_link');
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    }

    updateMoneyConvertible() {
      if (this.moneyConvertible && this.total) {
        this.moneyConvertible.textContent = '$' + (this.total.textContent ?? '');
      }
    }

    observeTotalChanges() {
      if (!this.total) return;
      if (this.totalObserver) this.totalObserver.disconnect();
      this.totalObserver = new MutationObserver(() =>
        this.updateMoneyConvertible()
      );
      this.totalObserver.observe(this.total, {
        childList: true,
        characterData: true,
        subtree: true,
      });
      this.updateMoneyConvertible();
    }
  }

  window.customElements.define('build-form', BuildForm);
})();
